import { getCurrentProjectData } from '@/auth/utils'
import { coreApiPageFilterHurriyetObject } from '@/coreApi/filters/coreApiPageFilterHurriyet'
import { coreApiPageFilterHurriyetcomObject } from '@/coreApi/filters/coreApiPageFilterHurriyetcom'
import { coreApiPageFilterBigparaObject } from '@/coreApi/filters/coreApiPageFilterBigpara'
import { coreApiPageFilterMilliyetObject } from '@/coreApi/filters/coreApiPageFilterMilliyet'
import { coreApiPageFilterMilliyetcomObject } from '@/coreApi/filters/coreApiPageFilterMilliyetcom'
import { coreApiPageFilterUzmanparaObject } from '@/coreApi/filters/coreApiPageFilterUzmanpara'
import { coreApiPageFilterPostaObject } from '@/coreApi/filters/coreApiPageFilterPosta'
import { coreApiPageFilterFanatikObject } from '@/coreApi/filters/coreApiPageFilterFanatik'
import { coreApiPageFilterKanaldObject } from '@/coreApi/filters/coreApiPageFilterKanald'
import { coreApiPageFilterTeve2Object } from '@/coreApi/filters/coreApiPageFilterTeve2'
import { coreApiPageFilterGazetevatanObject } from '@/coreApi/filters/coreApiPageFilterGazetevatan'
import { coreApiPageFilterCnnturkObject } from '@/coreApi/filters/coreApiPageFilterCnnturk'
import { coreApiPageFilterIgnObject } from '@/coreApi/filters/coreApiPageFilterIgn'
import { coreApiPageFilterMashableObject } from '@/coreApi/filters/coreApiPageFilterMashable'
import { coreApiPageFilterMilliyetSecimObject } from '@/coreApi/filters/coreApiPageFilterMilliyetSecim'
import { coreApiPageFilterCnnturkSecimObject } from '@/coreApi/filters/coreApiPageFilterCnnturkSecim'
import { coreApiPageFilterHurriyetSecimObject } from '@/coreApi/filters/coreApiPageFilterHurriyetSecim'
import { coreApiPageFilterGazetevatanSecimObject } from '@/coreApi/filters/coreApiPageFilterGazetevatanSecim'
import { coreApiPageFilterPostaSecimObject } from '@/coreApi/filters/coreApiPageFilterPostakSecim'
import { coreApiPageFilterRadyodObject } from '@/coreApi/filters/coreApiPageFilterRadyod'
import { coreApiPageFilterTamindirObject } from '@/coreApi/filters/coreApiPageFilterTamindir'
import { coreApiPageFilterOyunkoluObject } from '@/coreApi/filters/coreApiPageFilterOyunkolu'
import { coreApiPageFilterTurunculevyeObject } from '@/coreApi/filters/coreApiPageFilterTurunculevye'
import { coreApiPageFilterKisadalgaObject } from '@/coreApi/filters/coreApiPageKisadalga'
import { coreApiPageFilterRotaborsaObject } from '@/coreApi/filters/coreApiPageRotaborsa'
import { coreApiPageFilterHurriyetdailynewsObject } from '@/coreApi/filters/coreApiPageFilterHurriyetdailynews'
import { coreApiPageFilterHaberlerObject } from '@/coreApi/filters/coreApiPageFilterHaberler'
import { coreApiPageFilterSondakikaObject } from '@/coreApi/filters/coreApiPageFilterSonDakika'
import { coreApiPageFilterDunyaObject } from '@/coreApi/filters/coreApiPageFilterDunya'
import { coreApiPageFilterOdatvObject} from '@/coreApi/filters/coreApiPageFilterOdatv'
import { coreApiPageFilterT24Object } from '@/coreApi/filters/coreApiPageFilterT24'
import { coreApiPageFilterCnbcEObject } from '@/coreApi/filters/coreApiPageFilterCnbcE'

export const getProjectCoreProjectId = () => {
    const currentProjectData = getCurrentProjectData()

    let projectId = ''
    // eslint-disable-next-line default-case
    if (currentProjectData) {
        switch (currentProjectData.projectId) {
        case 'D-01F1B-2':
            projectId = 'bl2ok5med65lk2'
            break
        case 'D-01F1B-3':
            projectId = 'bl8372p22-cn'
            break
        case 'D-01F1B-4':
            projectId = 'bl8372p22-ps'
            break
        case 'D-01F1B-5':
            projectId = 'bl8372p22-fn'
            break
        case 'D-01F1B-6':
            projectId = 'bl8372p22-kd'
            break
        case 'D-01F1B-7':
            projectId = 'bl8372p22-tv'
            break
        case 'D-01F1B-8':
            projectId = 'bl8372p22-gv'
            break
        case 'D-01F1B-9':
            projectId = 'bl8372p22-ign'
            break
        case 'D-01F1B-10':
            projectId = 'bl8372p22-ma'
            break
        case 'D-01F1B-11':
            projectId = 'bl8372p22-hs'
            break
        case 'D-01F1B-12':
            projectId = 'bl8372p22-ms'
            break
        case 'D-01F1B-13':
            projectId = 'bl8372p22-cns'
            break
        case 'D-01F1B-14':
            projectId = 'bl8372p22-psts'
            break
        case 'D-01F1B-15':
            projectId = 'bl8372p22-gvs'
            break
        case 'D-01F1B-16':
            projectId = 'bl8372p22-rd'
            break
        case 'D-01F1B-17':
            projectId = 'bl8372p22-hdn'
            break
        case 'D-01F1B-18':
            projectId = 'bl1767ftdlk224-ho'
            break
        case 'D-01F1B-19':
            projectId = 'bl1767ftdlk224-hbo'
            break
        case 'D-01F1B-20':
            projectId = 'bl2ok5med65lk2-mo'
            break
        case 'D-01F1B-21':
            projectId = 'bl2ok5med65lk2-muo'
            break
        case 'D-01F1C-1':
            projectId = 'dmp-202634'
            break
        case 'D-01F1C-2':
            projectId = 'dmp-202635'
            break
        case 'D-01F1C-3':
            projectId = 'dmp-202636'
            break
        case 'D-01F1D-1':
            projectId = 'dmp-202637'
            break
        case 'D-01F1E-1':
            projectId = 'dmp-202638'
            break
        case 'D-01F1F-1':
            projectId = 'dmp-2026A9'
            break
        case 'D-01F1F-2':
            projectId = 'dmp-2026B0'
            break
        case 'D-01F1G-1':
            projectId = 'dmp-337745'
            break
        case 'D-01F1H-1':
            projectId = 'dmp-120606'
            break
        case 'D-01F1J-1':
            projectId = 'dmp-202401'
            break
        case 'D-01F1K-1':
            projectId = 'dmp-202402'
            break
        case 'D-01F1B-1':
            projectId = 'bl1767ftdlk224'
        }
    }

    return projectId
}

export const getProjectCoreProjectIdById = projectMainId => {
    let projectId
    // eslint-disable-next-line default-case
    switch (projectMainId) {
    case 'D-01F1B-2':
        projectId = 'bl2ok5med65lk2'
        break
    case 'D-01F1B-3':
        projectId = 'bl8372p22-cn'
        break
    case 'D-01F1B-4':
        projectId = 'bl8372p22-ps'
        break
    case 'D-01F1B-5':
        projectId = 'bl8372p22-fn'
        break
    case 'D-01F1B-6':
        projectId = 'bl8372p22-kd'
        break
    case 'D-01F1B-7':
        projectId = 'bl8372p22-tv'
        break
    case 'D-01F1B-8':
        projectId = 'bl8372p22-gv'
        break
    case 'D-01F1B-9':
        projectId = 'bl8372p22-ign'
        break
    case 'D-01F1B-10':
        projectId = 'bl8372p22-ma'
        break
    case 'D-01F1B-11':
        projectId = 'bl8372p22-hs'
        break
    case 'D-01F1B-12':
        projectId = 'bl8372p22-ms'
        break
    case 'D-01F1B-13':
        projectId = 'bl8372p22-cns'
        break
    case 'D-01F1B-14':
        projectId = 'bl8372p22-psts'
        break
    case 'D-01F1B-15':
        projectId = 'bl8372p22-gvs'
        break
    case 'D-01F1B-16':
        projectId = 'bl8372p22-rd'
        break
    case 'D-01F1B-17':
        projectId = 'bl8372p22-hdn'
        break
    case 'D-01F1B-18':
        projectId = 'bl1767ftdlk224-ho'
        break
    case 'D-01F1B-19':
        projectId = 'bl1767ftdlk224-hbo'
        break
    case 'D-01F1B-20':
        projectId = 'bl2ok5med65lk2-mo'
        break
    case 'D-01F1B-21':
        projectId = 'bl2ok5med65lk2-muo'
        break
    case 'D-01F1C-1':
        projectId = 'dmp-202634'
        break
    case 'D-01F1C-2':
        projectId = 'dmp-202635'
        break
    case 'D-01F1C-3':
        projectId = 'dmp-202636'
        break
    case 'D-01F1D-1':
        projectId = 'dmp-202637'
        break
    case 'D-01F1E-1':
        projectId = 'dmp-202638'
        break
    case 'D-01F1F-1':
        projectId = 'dmp-2026A9'
        break
    case 'D-01F1F-2':
        projectId = 'dmp-2026B0'
        break
    case 'D-01F1G-1':
        projectId = 'dmp-337745'
        break
    case 'D-01F1H-1':
        projectId = 'dmp-120606'
        break
    case 'D-01F1J-1':
        projectId = 'dmp-202401'
        break
    case 'D-01F1K-1':
        projectId = 'dmp-202402'
        break
    case 'D-01F1B-1':
        projectId = 'bl1767ftdlk224'
    }

    return projectId
}
export const getProjectProjectIdByCoreId = cronProjectId => {
    let projectId
    // eslint-disable-next-line default-case
    switch (cronProjectId) {
    case 'bl2ok5med65lk2':
        projectId = 'D-01F1B-2'
        break
    case 'bl2ok5med65lk2-mo':
        projectId = 'D-01F1B-20'
        break
    case 'bl2ok5med65lk2-muo':
        projectId = 'D-01F1B-21'
        break
    case 'bl8372p22-cn':
        projectId = 'D-01F1B-3'
        break
    case 'bl8372p22-ps':
        projectId = 'D-01F1B-4'
        break
    case 'bl8372p22-fn':
        projectId = 'D-01F1B-5'
        break
    case 'bl8372p22-kd':
        projectId = 'D-01F1B-6'
        break
    case 'bl8372p22-tv':
        projectId = 'D-01F1B-7'
        break
    case 'bl8372p22-gv':
        projectId = 'D-01F1B-8'
        break
    case 'bl8372p22-ign':
        projectId = 'D-01F1B-9'
        break
    case 'D-01F1B-10':
        projectId = 'bl8372p22-ma'
        break
    case 'bl8372p22-hs':
        projectId = 'D-01F1B-11'
        break
    case 'bl8372p22-ms':
        projectId = 'D-01F1B-12'
        break
    case 'bl8372p22-cns':
        projectId = 'D-01F1B-13'
        break
    case 'bl8372p22-psts':
        projectId = 'D-01F1B-14'
        break
    case 'bl8372p22-gvs':
        projectId = 'D-01F1B-15'
        break
    case 'bl8372p22-rd':
        projectId = 'D-01F1B-16'
        break
    case 'bl8372p22-hdn':
        projectId = 'D-01F1B-17'
        break
    case 'dmp-202634':
        projectId = 'D-01F1C-1'
        break
    case 'dmp-202635':
        projectId = 'D-01F1C-2'
        break
    case 'dmp-202636':
        projectId = 'D-01F1C-3'
        break
    case 'dmp-202637':
        projectId = 'D-01F1D-1'
        break
    case 'dmp-202638':
        projectId = 'D-01F1E-1'
        break
    case 'dmp-2026A9':
        projectId = 'D-01F1F-1'
        break
    case 'dmp-2026B0':
        projectId = 'D-01F1F-2'
        break
    case 'dmp-337745':
        projectId = 'D-01F1G-1'
        break
    case 'dmp-120606':
        projectId = 'D-01F1H-1'
        break
    case 'dmp-202401':
        projectId = 'D-01F1J-1'
        break
    case 'dmp-202402':
        projectId = 'D-01F1K-1'
        break
    case 'bl1767ftdlk224':
        projectId = 'D-01F1B-1'
        break
    case 'bl1767ftdlk224-ho':
        projectId = 'D-01F1B-18'
        break
    case 'bl1767ftdlk224-hbo':
        projectId = 'D-01F1B-19'
        break
    }

    return projectId
}

export const getProjectCoreProjectName = () => {
    const currentProjectData = getCurrentProjectData()

    let projectName = ''
    // eslint-disable-next-line default-case
    if (currentProjectData) {
        switch (currentProjectData.projectId) {
        case 'D-01F1B-2':
            projectName = 'milliyet'
            break
        case 'D-01F1B-20':
            projectName = 'milliyetcom'
            break
        case 'D-01F1B-21':
            projectName = 'uzmanpara'
            break
        case 'D-01F1B-3':
            projectName = 'cnnturk'
            break
        case 'D-01F1B-4':
            projectName = 'posta'
            break
        case 'D-01F1B-5':
            projectName = 'fanatik'
            break
        case 'D-01F1B-6':
            projectName = 'kanald'
            break
        case 'D-01F1B-7':
            projectName = 'teve2'
            break
        case 'D-01F1B-8':
            projectName = 'vatan'
            break
        case 'D-01F1B-9':
            projectName = 'ign'
            break
        case 'D-01F1B-10':
            projectName = 'mashable'
            break
        case 'D-01F1B-11':
            projectName = 'hurriyetSecim'
            break
        case 'D-01F1B-12':
            projectName = 'milliyetSecim'
            break
        case 'D-01F1B-13':
            projectName = 'cnnturkSecim'
            break
        case 'D-01F1B-14':
            projectName = 'postaSecim'
            break
        case 'D-01F1B-15':
            projectName = 'vatanSecim'
            break
        case 'D-01F1B-16':
            projectName = 'radyod'
            break
        case 'D-01F1B-17':
            projectName = 'hurriyetDailyNews'
            break
        case 'D-01F1B-18':
            projectName = 'hurriyetcom'
            break
        case 'D-01F1B-19':
            projectName = 'bigpara'
            break
        case 'D-01F1C-1':
            projectName = 'tamindir'
            break
        case 'D-01F1C-2':
            projectName = 'oyunkolu'
            break
        case 'D-01F1C-3':
            projectName = 'turunculevye'
            break
        case 'D-01F1D-1':
            projectName = 'kisadalga'
            break
        case 'D-01F1E-1':
            projectName = 'rotaborsa'
            break
        case 'D-01F1F-1':
            projectName = 'haberler'
            break
        case 'D-01F1F-2':
            projectName = 'sondakika'
            break
        case 'D-01F1G-1':
            projectName = 'dunya'
            break
        case 'D-01F1H-1':
            projectName = 'odatv'
            break
        case 'D-01F1J-1':
            projectName = 't24'
            break
        case 'D-01F1K-1':
            projectName = 'cnbce'
            break
        case 'D-01F1B-1':
            projectName = 'hurriyet'
        }
    }

    return projectName
}
export const getProjectCoreProjectNameById = projectId => {
    let projectName = null
    // eslint-disable-next-line default-case
    switch (projectId) {
    case 'bl2ok5med65lk2':
        projectName = 'milliyet'
        break
    case 'bl2ok5med65lk2-mo':
        projectName = 'milliyetcom'
        break
    case 'bl2ok5med65lk2-muo':
        projectName = 'uzmanpara'
        break
    case 'bl8372p22-cn':
        projectName = 'cnnturk'
        break
    case 'bl8372p22-ps':
        projectName = 'posta'
        break
    case 'bl8372p22-fn':
        projectName = 'fanatik'
        break
    case 'bl8372p22-kd':
        projectName = 'kanald'
        break
    case 'bl8372p22-tv':
        projectName = 'teve2'
        break
    case 'bl8372p22-gv':
        projectName = 'vatan'
        break
    case 'bl8372p22-ign':
        projectName = 'ign'
        break
    case 'bl8372p22-ma':
        projectName = 'mashable'
        break
    case 'bl8372p22-hs':
        projectName = 'hurriyetSecim'
        break
    case 'bl8372p22-ms':
        projectName = 'milliyetSecim'
        break
    case 'bl8372p22-cns':
        projectName = 'cnnturkSecim'
        break
    case 'bl8372p22-psts':
        projectName = 'postaSecim'
        break
    case 'bl8372p22-gvs':
        projectName = 'vatanSecim'
        break
    case 'bl8372p22-rd':
        projectName = 'radyod'
        break
    case 'bl8372p22-hdn':
        projectName = 'hurriyetDailyNews'
        break
    case 'dmp-202634':
        projectName = 'tamindir'
        break
    case 'dmp-202635':
        projectName = 'oyunkolu'
        break
    case 'dmp-202636':
        projectName = 'turunculevye'
        break
    case 'dmp-202637':
        projectName = 'kisadalga'
        break
    case 'dmp-202638':
        projectName = 'rotaborsa'
        break
    case 'dmp-2026A9':
        projectName = 'haberler'
        break
    case 'dmp-2026B0':
        projectName = 'sondakika'
        break
    case 'dmp-120606':
        projectName = 'odatv'
        break
    case 'dmp-202401':
        projectName = 't24'
        break
    case 'dmp-202402':
        projectName = 'cnbce'
        break
    case 'dmp-337745':
        projectName = 'dunya'
        break
    case 'bl1767ftdlk224':
        projectName = 'hurriyet'
        break
    case 'bl1767ftdlk224-ho':
        projectName = 'hurriyetcom'
        break
    case 'bl1767ftdlk224-hbo':
        projectName = 'bigpara'
        break
    }
    return projectName
}

export const getProjectFilterObject = () => {
    let filterObject = null
    // eslint-disable-next-line default-case
    switch (getProjectCoreProjectName()) {
    case 'milliyet':
        filterObject = coreApiPageFilterMilliyetObject
        break
    case 'milliyetcom':
        filterObject = coreApiPageFilterMilliyetcomObject
        break
    case 'uzmanpara':
        filterObject = coreApiPageFilterUzmanparaObject
        break
    case 'cnnturk':
        filterObject = coreApiPageFilterCnnturkObject
        break
    case 'posta':
        filterObject = coreApiPageFilterPostaObject
        break
    case 'fanatik':
        filterObject = coreApiPageFilterFanatikObject
        break
    case 'kanald':
        filterObject = coreApiPageFilterKanaldObject
        break
    case 'teve2':
        filterObject = coreApiPageFilterTeve2Object
        break
    case 'vatan':
        filterObject = coreApiPageFilterGazetevatanObject
        break
    case 'ign':
        filterObject = coreApiPageFilterIgnObject
        break
    case 'mashable':
        filterObject = coreApiPageFilterMashableObject
        break
    case 'hurriyetSecim':
        filterObject = coreApiPageFilterHurriyetSecimObject
        break
    case 'milliyetSecim':
        filterObject = coreApiPageFilterMilliyetSecimObject
        break
    case 'cnnturkSecim':
        filterObject = coreApiPageFilterCnnturkSecimObject
        break
    case 'postaSecim':
        filterObject = coreApiPageFilterPostaSecimObject
        break
    case 'vatanSecim':
        filterObject = coreApiPageFilterGazetevatanSecimObject
        break
    case 'radyod':
        filterObject = coreApiPageFilterRadyodObject
        break
    case 'hurriyetDailyNews':
        filterObject = coreApiPageFilterHurriyetdailynewsObject
        break
    case 'tamindir':
        filterObject = coreApiPageFilterTamindirObject
        break
    case 'oyunkolu':
        filterObject = coreApiPageFilterOyunkoluObject
        break
    case 'turunculevye':
        filterObject = coreApiPageFilterTurunculevyeObject
        break
    case 'kisadalga':
        filterObject = coreApiPageFilterKisadalgaObject
        break
    case 'rotaborsa':
        filterObject = coreApiPageFilterRotaborsaObject
        break
    case 'haberler':
        filterObject = coreApiPageFilterHaberlerObject
        break
    case 'sondakika':
        filterObject = coreApiPageFilterSondakikaObject
        break
    case 'dunya':
        filterObject = coreApiPageFilterDunyaObject
        break
    case 'hurriyet':
        filterObject = coreApiPageFilterHurriyetObject
        break
    case 'hurriyetcom':
        filterObject = coreApiPageFilterHurriyetcomObject
        break
    case 'bigpara':
        filterObject = coreApiPageFilterBigparaObject
        break
    case 'odatv':
        filterObject = coreApiPageFilterOdatvObject
        break
    case 't24':
        filterObject = coreApiPageFilterT24Object
        break
    case 'cnbce':
        filterObject = coreApiPageFilterCnbcEObject
        break
    }
    return filterObject
}
